import moment from "moment";
import { ContractAPI } from "../api";
import { Customer } from "./";
import { Area } from "./Area.class";
import { ContractLog } from "./ContractLog.class";
export class Contract {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    if (props.customer) {
      this.customer = new Customer(props.customer);
      this.customerId = this.customer.customerId || '-'
    }
    if (props.areas && props.areas.length) this.areas = this.areas.map(item => new Area(item));
    if (props.renewEffectiveContract) this.renewEffectiveContract = new Contract(props.renewEffectiveContract)
    this.renewEffectiveDateFormat = props.renewEffectiveDate ? moment(props.renewEffectiveDate.iso).format('DD MMM YYYY') : ''
    this.isRenewEffective = this.renewEffectiveContract && this.renewEffectiveDateFormat ? true : false
    this.startDateFormat = props.startDate ? moment(props.startDate.iso).format('DD MMM YYYY') : '-'
    this.endDateFormat = props.endDate ? moment(props.endDate.iso).format('DD MMM YYYY') : '-'
    this.createdAtFormat = moment(props.createdAt).format('DD MMM YYYY')
    this.stallTypeText = !this.stallType ? '-' : this.stallType == "temporary" ? 'ชั่วคราว' : 'ประจำ'

    this.billingDataName = !this.billingData ? '-' : this.billingData.name ? this.billingData.name : '-'
    this.billingDataBranchName = !this.billingData ? '-' : this.billingData.branchName ? this.billingData.branchName : '-'
    this.billingDataTaxId = !this.billingData ? '-' : this.billingData.taxId ? this.billingData.taxId : '-'
    this.billingDataAddress = !this.billingData ? '-' : this.billingData.address ? this.billingData.address : '-'
    this.billingDataTel = !this.billingData ? '-' : this.billingData.tel ? this.billingData.tel : '-'
    this.billingDataEmail = !this.billingData ? '-' : this.billingData.email ? this.billingData.email : '-'

    this.status = this.isSuspend ? { code: "001", text: "พักการค้า", color: "warning white--text" } : !this.isPaid ? { code: "002", text: "ค้างชำระ", color: "red white--text" } : { code: "003", text: "ไม่มีหนี้ค้าง", color: "green white--text" };
    this.statusClass = this.isSuspend ? { code: "001", text: "พักค้า", class: "warning" } : !this.isPaid ? { code: "002", text: "ค้างชำระ", class: "error" } : { code: "003", text: "ไม่มีหนี้ค้าง", class: "success" };
    this.checkStatus = this.isPaid && !this.isSuspend ? true : false;
    this.checkRenew = !this.isSuspend && !this.renewAppeal ? true : false;
    this.checkRenewApprove = !this.isPaid ? true : false;
    this.expiredThresholdDays = 90
    if(props.market?.setting?.contractExpiredThresholdDays) this.expiredThresholdDays = props.market.setting.contractExpiredThresholdDays
  }

  get dayMonthYearText() {
    let days = 0;
    let months = 0;
    let years = 0;
    let text = "";
    if (this.startDate && this.startDate.iso && this.endDate && this.endDate.iso) {
      let a = moment(this.endDate.iso).endOf("day");
      let b = moment(this.startDate.iso).startOf("day");
      a.add(1, "days");
      years = a.diff(b, "year");
      b.add(years, "years");
      months = a.diff(b, "months");
      b.add(months, "months");
      days = a.diff(b, "days");
    }
    if (years) text += `${years} ปี `;
    if (months) text += `${months} เดือน `;
    if (days) text += `${days} วัน`;
    return text;
  }
  get diffDays() {
    let days = 0;
    let minutes = 0;
    if (this.startDate && this.startDate.iso && this.endDate && this.endDate.iso) {
      minutes = moment(this.endDate.iso).diff(moment(this.startDate.iso), "minutes") || 0;
      days = Math.ceil(minutes / (24 * 60));
    }
    return days;
  }
  get ageExpire() {
    let res = 0;
    if (this.endDate && this.endDate.iso) {
      res = moment(this.endDate.iso).diff(moment(), "days");
    }
    return res;
  }
  get ageExpireStatus() {
    let res = { text: '-', color: 'gray' }
    if(this.renewAppeal){
      res.text = 'รออนุมัติ'
      res.color = 'warning'
    }else{
      if (this.ageExpire < 0) {
        res.text = 'หมดอายุแล้ว'
        res.color = 'error'
      } else if (this.ageExpire == 0) {
        res.text = 'วันนี้'
        res.color = 'warning'
      } else if (this.ageExpire > 0 && this.ageExpire <= this.expiredThresholdDays) {
        res.text = `ในอีก ${this.ageExpire} วัน`
        res.color = 'info'
      } else if (this.ageExpire >= this.expiredThresholdDays) {
        res.text = `ในอีก ${this.ageExpire} วัน`
        res.color = 'success'
      }
    }
    return res
  }
  get customerFullName() {
    let res = "-";
    if (this.customer && this.customer.type == "company") {
      res = `${this.customer.companyName}`;
    } else if (this.customer && this.customer.type == "personal") {
      res = `${this.customer.title} ${this.customer.firstName} ${this.customer.lastName}`;
    }
    return res;
  }
  get alertAgeExpire() {
    return this.ageExpire <= this.expiredThresholdDays ? true : false
  }

  get closeContractStatus(){
    let res = { text: "", icon: "" };
    if(!this.isActive ){
      if(this.closeContractAt && this.closeContractAt.iso && this.endDate && this.endDate.iso){
        const closeDate = moment(this.closeContractAt.iso);
        const endDate = moment(this.endDate.iso);
        if(closeDate.diff(endDate) >= 0){
          res.text = "อยู่ครบสัญญา";
          res.icon = "contract_complete.svg"
        } else {
          res.text = "อยู่ไม่ครบสัญญา";
          res.icon = "contract_not_complete.svg"
        }
      }else{
        res.text = "อยู่ครบสัญญา";
        res.icon = "contract_complete.svg"
      }
    }
    return res;
  }

  get areasText() {
    let res = "-";
    if (this.areas && this.areas.length) {
      res = this.areas.map(i => i.name).join(", ");
    }
    return res;
  }
  get isNotCheckInArea() {
    return this.isActive && this.areas.find(d => d.contract && d.contract.objectId != this.objectId) ? true : false
  }
  static async getContract(payload) {
    const { data } = await ContractAPI.getContract(payload);
    return new Contract(data.result);
  }
  static async getContracts(payload) {
    const { data } = await ContractAPI.getContracts(payload);
    return data.result.map(item => new Contract(item));
  }
  static async renewContract(payload) {
    const { data } = await ContractAPI.renewContract(payload);
    return {
      oldContract: data.result.oldContract ? new Contract(data.result.oldContract) : null,
      newContract: data.result.newContract ? new Contract(data.result.newContract) : null,
      contractDocuments: data.result.contractDocuments
    }
  }
  static async createContract(payload) {
    const { data } = await ContractAPI.createContract(payload);
    return new Contract(data.result);
  }
  static async getContractsByCustomer(payload) {
    const { data } = await ContractAPI.getContractsByCustomer(payload);
    return data.result.map(item => new Contract(item));
  }
  static async updateContract(payload) {
    const { data } = await ContractAPI.updateContract(payload);
    return new Contract(data.result);
  }
  static async addContractArea(payload) {
    const { data } = await ContractAPI.addContractArea(payload);
    return new Contract(data.result);
  }
  static async removeContractArea(payload) {
    const { data } = await ContractAPI.removeContractArea(payload);
    return new Contract(data.result);

  }
  static async getNewContractsBetweenDateByMarket(marketId, startDate, endDate) {
    const { data } = await ContractAPI.getNewContractsBetweenDateByMarket(marketId, startDate, endDate);
    return data.result.map(item => new Contract(item));
  }
  static async getContractsBetweenDateByMarket(marketId, startDate, endDate) {
    const { data } = await ContractAPI.getContractsBetweenDateByMarket(marketId, startDate, endDate);
    return data.result.map(item => new Contract(item));
  }
  static async getActiveContractsBetweenDateByMarket(marketId, startDate, endDate) {
    const { data } = await ContractAPI.getActiveContractsBetweenDateByMarket(marketId, startDate, endDate);
    return data.result.map(item => new Contract(item));
  }
  static async getActiveContractByMarket(formData) {
    const { data } = await ContractAPI.getActiveContractByMarket(formData);
    return data.result.map(item => new Contract(item));
  }
  static async getContractWillExpiredByMarket(formData) {
    const { data } = await ContractAPI.getContractWillExpiredByMarket(formData);
    return data.result.map(item => new Contract(item));
  }
}
